import axios from 'axios';
import { ENDERECO_API } from '../config/constant';

const axiosServices = axios.create({
  baseURL: ENDERECO_API,
});

axiosServices.interceptors.response.use(

 
  (response) => {
    if (response.data === 'sessao_expirada') {
      sessionStorage.clear();
      window.location.href = '/auth/login';
      return Promise.reject({ code: 'SESSION_EXPIRED' });
    }else if (response.data === 'erro_auth') {
      sessionStorage.clear();
      window.location.href = '/auth/login';
      return Promise.reject({ code: 'AUTH_ERROR' });
    }
    return response;
  },
  (error) => {    
    const resp = error && error.response;
    const errorMessage = error && typeof error.message === 'string' ? error.message : '';
    const isJsonParseError = errorMessage.includes('is not valid JSON') || errorMessage.includes('Unexpected token');
    
    // Se não há resposta, pode ser problema de conexão
    if (!resp) {
      const reqUrl = (error && error.config && (error.config.baseURL || '') + (error.config.url || '')) || '';
      const networkError = {
        message: isJsonParseError ? 'Resposta inválida do servidor' : 'Serviço indisponível',
        details: isJsonParseError
          ? reqUrl
            ? `Falha ao interpretar a resposta do servidor (${reqUrl}). O conteúdo retornado não é JSON válido.`
            : 'Falha ao interpretar a resposta do servidor. O conteúdo retornado não é JSON válido.'
          : reqUrl
          ? `Não foi possível conectar ao servidor (${reqUrl}). Verifique se o serviço está rodando.`
          : 'Não foi possível conectar ao servidor. Verifique se o serviço está rodando.',
        code: isJsonParseError ? 'INVALID_RESPONSE' : 'NETWORK_ERROR',
        originalError: errorMessage || undefined,
      };
      // console.error('Erro de conexão:', networkError);
      return Promise.reject(networkError);
    }
    
    // Se há resposta com dados, retorna os dados
    if (resp && typeof resp.data !== 'undefined') {
      return Promise.reject(resp.data);
    }
    
    const msg = (error && (error.message || error.statusText)) || 'Serviço indisponível';
    return Promise.reject(msg);
  }
);

export default axiosServices;
